import { render } from "./QuerySource.vue?vue&type=template&id=62968960&class=text-center"
import script from "./QuerySource.vue?vue&type=script&lang=js"
export * from "./QuerySource.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__